import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import useLanguageStore from '~/helpers/store/locale/locale'
import { en } from '~/i18n/en'
import { fr } from '~/i18n/fr'

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
}

// Get initial language from store
const initialLanguage = useLanguageStore.getState().locale

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: initialLanguage, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

// Subscribe to store changes to update i18n language
useLanguageStore.subscribe((state) => {
  if (i18n.language !== state.locale) {
    i18n.changeLanguage(state.locale)
  }
})

export default i18n
